import { render, staticRenderFns } from "./dicitonaryMediaEdit.vue?vue&type=template&id=0657af87&scoped=true&"
import script from "./dicitonaryMediaEdit.vue?vue&type=script&lang=js&"
export * from "./dicitonaryMediaEdit.vue?vue&type=script&lang=js&"
import style0 from "./dicitonaryMediaEdit.vue?vue&type=style&index=0&id=0657af87&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0657af87",
  null
  
)

export default component.exports